export const getTruthValue = (value: unknown, initialValue: unknown) => {
  if (value === null) {
    return value
  }

  return value ?? initialValue
}
